import React, { forwardRef, useState } from 'react';
import classes from '../PostEditorModal/PostEditorModal.module.scss';
import { PostEditorGroupDataProvider } from '../states/PostEditorGroupDataProvider';
import { PostEditorHeader } from '../PostEditorHeader';
import { PostEditorBody } from '../PostEditorBody';
import { PostEditorModal } from '../PostEditorModal';
import { SubmitErrorHandler, UseFormReturn } from 'react-hook-form';
import { PostEditorProvider } from '../states/PostEditorProvider';
import { UsePostEditorResult } from '../../../hooks/usePostEditorNew';
import {
  OnSubmitErrorPostEditorFunction,
  OnSubmitPostEditorFunction
} from '../PostEditorModal/PostEditorModal.controller';
import { PostEditorSubmitData } from '../../../models/post-editor';
import { SubmitHandler } from 'react-hook-form/dist/types/form';
import { SocialProfileWithBoardsAndMentionType } from '../helpers/mapSelectedProfilesValues';
import { MappedCategoriesType } from '../../Publish/Categories/Categories.helpers';

export type PostEditorEditViewProps = {
  //
  postId: string;
  initialState: UsePostEditorResult['initialState'];
  loading: UsePostEditorResult['loading'];
  onErrorHandler: OnSubmitErrorPostEditorFunction<SubmitErrorHandler<PostEditorSubmitData>>;
  onSubmitHandler: OnSubmitPostEditorFunction<SubmitHandler<PostEditorSubmitData>>;
  profiles: SocialProfileWithBoardsAndMentionType[];
  categories: MappedCategoriesType[];
  formInstance: UseFormReturn;
};

export const PostEditorEditView = forwardRef<HTMLDivElement | null, PostEditorEditViewProps>(
  (
    { postId, initialState, loading, onErrorHandler, onSubmitHandler, categories, profiles, formInstance },
    ref
  ): JSX.Element => {
    const [initialised, setInitialised] = useState<boolean>(false);

    return (
      <>
        {!initialised ? (
          <PostEditorModal
            title={'Edit Post'}
            formInstance={formInstance}
            loading={true}
            onErrorHandler={onErrorHandler}
            onSubmitHandler={onSubmitHandler}>
            <></>
          </PostEditorModal>
        ) : null}
        {initialState && !loading ? (
          <PostEditorProvider initialState={initialState} loading={false} categories={categories} profiles={profiles}>
            <PostEditorModal
              title={'Edit Post'}
              formInstance={formInstance}
              loading={false}
              setInitialised={setInitialised}
              onErrorHandler={onErrorHandler}
              onSubmitHandler={onSubmitHandler}>
              <PostEditorGroupDataProvider postGroupIndex={0}>
                <div ref={ref} className={classes.ContentWrapper}>
                  <PostEditorHeader formInstance={formInstance} postId={postId} />
                  <PostEditorBody formInstance={formInstance} postId={postId} />
                </div>
              </PostEditorGroupDataProvider>
            </PostEditorModal>
          </PostEditorProvider>
        ) : null}
      </>
    );
  }
);
